import moment from 'moment';
import { compose, withHandlers } from 'recompose';

import withTimezone from '../../auth/utils/withTimezone';
import withDateFormat from '../../auth/utils/withDateFormat';

export default compose(
  withDateFormat(),
  withTimezone,
  withHandlers({
    dateToString: props => (date) => {
      if (typeof date === 'string') {
        return date;
      }
      return moment(date).tz(props.timezone).format(props.dateFormat);
    },
  })
);
